import { useAsync } from "@mylaunch/components/hooks"
import { Result } from "@praha/byethrow"
import { useQueryClient } from "@tanstack/react-query"
import { toast } from "sonner"
import { usePreOpenSystemBrowser } from "../hooks/use-pre-open-system-browser"
import { plansQueryKey } from "../hooks/use-plans"
import { changePaymentMethod } from "../server/plans.functions"

export function ChangeCardLink({ methodName, disabled }: { methodName?: string; disabled?: boolean } = {}) {
  const queryClient = useQueryClient()
  const browser = usePreOpenSystemBrowser()

  const { loading, run } = useAsync(() => {
    const returnUrl = `${location.origin}/?tab=profile&pay=return`
    return changePaymentMethod({ data: { returnUrl } })
  })

  const handleClick = async () => {
    const r = await run()
    if (Result.isFailure(r)) {
      browser.close()
      toast.error("Не удалось начать привязку карты")
      return
    }
    const { confirmationUrl } = r.value
    await queryClient.invalidateQueries({ queryKey: plansQueryKey })
    browser.goTo(confirmationUrl)
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      onMouseDown={() => browser.preOpen()}
      onTouchStart={() => browser.preOpen()}
      disabled={loading || disabled}
      className="text-sm text-secondary whitespace-nowrap disabled:opacity-50"
    >
      {methodName ? `${methodName} — изменить` : "Изменить карту"}
    </button>
  )
}
